module.exports = __webpack_public_path__ + "img/title6_4.5d3932b7.png";